/* eslint-disable global-require */
require(
    [
        "shared/util/Polyfill",
        "shared/zbone/Extend",
        "shared/zbone/Events",
        "shared/zbone/Layout",
        "shared/zbone/Region",
        "zbone/View",
        "shared/zbone/CollectionView",
        "zbone/CollectionView",
        "editor-mixins",
        "shared/util/JqueryCommonPlugins",
        "util/JqueryEditorPlugins",
        "backbone.wrapper",
        "bootstrap",
        "bootstrap-colorpicker",
        "bootstrap-datetimepicker",
        "bootstrap-switch",
        "backbone.stickit",
        "security/LoggedInNotifier"
    ], // set up handlers

    () => {
        "use strict";

        // Ensure the browser uses correct capabilities for the editor, not for the viewer...
        const Browser      = require("shared/services/Browser");
        const Capabilities = require("shared/util/BrowserCapabilitiesDetector");

        Browser.capabilities = Capabilities.detect(true);  // editor

        require(["app/EditorApplication", "shared/services/Configuration"], (app, config) => app.start(config));
    }
);



// WEBPACK FOOTER //
// ./src/editor/editor-main.js